import { useFormikContext } from 'formik';
import React from 'react';
import FieldFormControl from '../FieldFormControl';
import { OwnerAutocomplete } from '@/components/selects/OwnerSelect';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { InsightSelectFormikWrapper } from '../InsightSelectFormikWrapper';
import InsightFieldSelect from '@/components/selects/InsightFieldSelect';
import { FIELD_TYPES } from '@/features/insightFields';

const UserCreationInfoField = ({ field, type, disabled }) => {
	const { values, setFieldValue, getFieldMeta, getFieldProps, getFieldHelpers } =
		useFormikContext();

	const endpoint = field.field?.endpoint;
	const name = field.name;
	const fieldType = name?.endsWith('Id') ? name.slice(0, -2) : name;

	const isInsightSelectField = FIELD_TYPES.includes(fieldType);

	const { onBlur: onFieldBlur } = getFieldProps(field.name);
	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { error: errorMessage, touched } = getFieldMeta(name);
	const error = touched && Boolean(errorMessage);

	const { getFeatureFlags } = useFeatureFlagContext();
	const clientConfigInsightSelection = Boolean(
		getFeatureFlags('clientConfigInsightSelection')?.active,
	);

	const handleChange = (newUser) => {
		console.log('New user', newUser);
		setFieldValue(name, newUser?.[name === 'ownerDocId' ? 'id' : type]);
		setFieldValue(`${name}-docId`, newUser?.id);
		setFieldValue(`${name}-obj`, newUser);
		setFieldValue(`${name}-type`, 'user');
		if (name === 'ownerDocId') {
			const broker = newUser.brokerGroupData;
			['RecordPermissionsGroupId', 'BranchId'].forEach((v) => {
				setFieldValue(v, broker[v === 'BranchId' ? 'branchId' : 'permissionsGroup']);
				setFieldValue(`${v}-docId`, newUser?.brokerGroupId);
				setFieldValue(`${v}-obj`, broker);
				setFieldValue(`${v}-type`, 'brokerGroup');
			});
			if (newUser.authorisedRepId) {
				const authRepField = 'AuthorisedRep1Id';
				setFieldValue(authRepField, newUser.authorisedRepId);
				setFieldValue(`${authRepField}-docId`, newUser.id);
				setFieldValue(`${authRepField}-obj`, newUser);
				setFieldValue(`${authRepField}-type`, 'user');
			}
			if (newUser.salesTeamId) {
				const salesTeamField = 'SalesTeamId';
				setFieldValue(salesTeamField, newUser.salesTeamId);
				setFieldValue(`${salesTeamField}-docId`, newUser.id);
				setFieldValue(`${salesTeamField}-obj`, newUser);
				setFieldValue(`${salesTeamField}-type`, 'user');
			}
		}
	};

	if (clientConfigInsightSelection && endpoint) {
		return <InsightSelectFormikWrapper {...{ disabled, field }} />;
	}

	if (isInsightSelectField) {
		return (
			<FieldFormControl {...{ disabled, field }}>
				<InsightFieldSelect
					value={values[name]}
					fieldType={fieldType}
					onChange={(newValue) => setFieldValue(name, newValue?.insightId)}
					{...{ onBlur, error, disabled }}
				/>
			</FieldFormControl>
		);
	}

	return (
		<FieldFormControl {...{ disabled, field }}>
			<OwnerAutocomplete
				userId={values[`${name}-docId`]}
				onChange={handleChange}
				disableClearable={name === 'ownerDocId' || name === 'ownerId'}
				showGroup={true}
				filterBy={(user) => user?.[name === 'ownerDocId' ? 'id' : type] != null}
				{...(name !== 'ownerId' && name !== 'ownerDocId' && { displayField: type })}
				{...{ onBlur, error, disabled }}
			/>
		</FieldFormControl>
	);
};

export default UserCreationInfoField;
